import { fromJS, List } from 'immutable'

import * as requirementRequestActions from './RequirementRequestAction'

export const requirementRequestsInitialState = fromJS({
	isLoadingRequirementRequests: true,
	requirementRequests: null,
	isLoadingRequirementRequest: false,
	requirementRequest: null,
	requirementRequestInformation: null,
	sortCriteria: {
		by: 'creation_date',
		ascending: false,
	},
	searchQuery: '',
	page: 0,
	rowsPerPage: 20,
	requirementRequestsCount: null,
	isSaving: false,
})

export default function requirementRequestReducer(state = requirementRequestsInitialState, action) {
	switch (action.type) {
		case requirementRequestActions.START_LOADING_REQUIREMENT_REQUESTS: {
			return state.merge({
				isLoadingRequirementRequests: action.isLoading,
			})
		}
		case requirementRequestActions.SET_REQUIREMENT_REQUESTS_LIST: {
			return state.merge({
				requirementRequests: fromJS(action.requirementRequests),
				isLoadingRequirementRequests: false,
			})
		}
		case requirementRequestActions.IS_LOADING_REQUIREMENT_REQUEST: {
			return state.merge({
				isLoadingRequirementRequest: action.isLoadingRequirementRequest,
				...(action.isLoadingRequirementRequest
					? { requirementRequestInformation: null, requirementRequest: null }
					: {}),
			})
		}
		case requirementRequestActions.SET_REQUIREMENT_REQUEST: {
			return state.merge({
				isLoadingRequirementRequest: false,
				requirementRequest: fromJS(action.requirementRequest),
			})
		}
		case requirementRequestActions.SET_REQUIREMENT_REQUESTS_COUNT: {
			return state.merge({
				requirementRequestsCount: action.count,
			})
		}
		case requirementRequestActions.CHANGE_REQUIREMENT_REQUESTS_SORT_CRITERIA: {
			return state.merge({
				sortCriteria: action.sortCriteria,
			})
		}
		case requirementRequestActions.CHANGE_REQUIREMENT_REQUESTS_QUERY: {
			return state.merge({
				searchQuery: action.query,
				page: 0,
				rowsPerPage: state.get('rowsPerPage'),
			})
		}
		case requirementRequestActions.CHANGE_REQUIREMENT_REQUESTS_PAGINATION: {
			return state.merge({
				page: action.page,
				rowsPerPage: action.rowsPerPage,
			})
		}
		case requirementRequestActions.GET_INFORMATION_REQUIREMENT_REQUEST: {
			return state.merge({
				isLoadingRequirementRequest: false,
				requirementRequestInformation: fromJS(action.requirementRequest),
			})
		}
		case requirementRequestActions.UPDATE_REQUIREMENT_REQUEST: {
			return state.merge({
				isSaving: false,
				requirementRequest: fromJS(action.requirementRequest),
			})
		}
		case requirementRequestActions.IS_SAVING_REQUIREMENT_REQUEST: {
			return state.merge({
				isSaving: action.isSaving,
			})
		}
		case requirementRequestActions.ADD_SUPPLIER_TO_REQUIREMENT_REQUEST_DETAIL: {
			let details = state.getIn(['requirementRequestInformation', 'details'])
			let detailIndex = details.findIndex((d) => d.get('token') === action.detailToken)
			if (detailIndex === -1) return state
			return state.updateIn(
				['requirementRequestInformation', 'details', detailIndex, 'quotes'],
				(quotes) => (quotes || List()).push(fromJS(action.quote))
			)
		}
		case requirementRequestActions.REMOVE_SUPPLIER_FROM_REQUIREMENT_REQUEST_DETAIL: {
			let details = state.getIn(['requirementRequestInformation', 'details'])
			let detailIndex = details.findIndex((d) => d.get('token') === action.detailToken)
			if (detailIndex === -1) return state
			return state.updateIn(
				['requirementRequestInformation', 'details', detailIndex, 'quotes'],
				(quotes) => quotes.filter((q) => q.get('supplier_token') !== action.supplierToken)
			)
		}
		case requirementRequestActions.IS_UPDATING_PLOT_REQUIREMENT_REQUEST: {
			return state.merge({ isUpdatingPlot: action.isUpdating })
		}
		case requirementRequestActions.UPDATE_PLOT_REQUIREMENT_REQUEST_DETAIL: {
			let items = state.get('requirementRequestInformation').get('details').map((item) => {
				if (item.get('token') === action.detailPlane.token) {
					return item.set('plot_name', action.detailPlane.plot_name)
				}
				return item
			})
			let requirementRequestInformation = state.get('requirementRequestInformation').set('details', items)
			return state.merge({ requirementRequestInformation })
		}
		case requirementRequestActions.DELETE_PLOT_REQUIREMENT_REQUEST_DETAIL: {
			let items = state.get('requirementRequestInformation').get('details').map((item) => {
				if (item.get('token') === action.detailToken) {
					return item.set('plot_name', '')
				}
				return item
			})
			let requirementRequestInformation = state.get('requirementRequestInformation').set('details', items)
			return state.merge({ requirementRequestInformation })
		}
		case requirementRequestActions.UPDATE_COMMENTS_REQUIREMENT_REQUEST_DETAIL: {
			let items = state.get('requirementRequestInformation').get('details').map((item) => {
				if (item.get('token') === action.partNumberDetail.token) {
					return item.set('comments', action.partNumberDetail.comments)
				}
				return item
			})
			let requirementRequestInformation = state.get('requirementRequestInformation').set('details', items)
			return state.merge({ requirementRequestInformation })
		}
		case requirementRequestActions.ADD_FILE_REQUIREMENT_REQUEST_DETAIL: {
			let detailsList = state.getIn(['requirementRequestInformation', 'details']).toJS()
			let indexDetail = detailsList.findIndex((detail) => detail.token === action.tokenPartNumber)
			let oldList = (
				state.getIn(['requirementRequestInformation', 'details', indexDetail, 'attachments']) || List()
			).toJS()
			let filesToAdd = action.files.filter(
				(newFile) => !oldList.find((uploadedFile) => uploadedFile.name === newFile.name)
			)
			let newList = [...oldList, ...filesToAdd]
			return state.setIn(
				['requirementRequestInformation', 'details', indexDetail, 'attachments'],
				fromJS(newList)
			)
		}
		case requirementRequestActions.REMOVE_FILE_REQUIREMENT_REQUEST_DETAIL: {
			let detailsList = state.getIn(['requirementRequestInformation', 'details']).toJS()
			let indexDetail = detailsList.findIndex((detail) => detail.token === action.tokenPartNumber)
			let oldList = (
				state.getIn(['requirementRequestInformation', 'details', indexDetail, 'attachments']) || List()
			).toJS()
			let newList = oldList.filter((file) => file.name !== action.fileName)
			return state.setIn(
				['requirementRequestInformation', 'details', indexDetail, 'attachments'],
				fromJS(newList)
			)
		}
		case requirementRequestActions.ADD_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL: {
			return state.updateIn(['requirementRequestInformation', 'details'], (allDetails) => {
				let index = allDetails.findIndex((detail) => detail.get('token') === action.detailToken)
				if (index === -1) return allDetails
				let detailToChange = allDetails.get(index)
				let quoteIndex = detailToChange
					.get('quotes')
					.findIndex((q) => q.get('supplier_token') === action.supplierToken)
				if (quoteIndex === -1) return allDetails
				let updatedQuoteList = detailToChange.get('quotes')
				let updateQuote = updatedQuoteList.get(quoteIndex).set('is_sample_requiered', true)
				updatedQuoteList = updatedQuoteList.setIn([quoteIndex], updateQuote)
				return allDetails.setIn([index], detailToChange.set('quotes', updatedQuoteList))
			})
		}
		case requirementRequestActions.ADD_RMI_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL: {
			return state.updateIn(['requirementRequestInformation', 'details'], (allDetails) => {
				let index = allDetails.findIndex((detail) => detail.get('token') === action.detailToken)
				if (index === -1) return allDetails
				let detailToChange = allDetails.get(index)
				let quoteIndex = detailToChange
					.get('quotes')
					.findIndex((q) => q.get('supplier_token') === action.supplierToken)
				if (quoteIndex === -1) return allDetails
				let updatedQuoteList = detailToChange.get('quotes')
				let updateQuote = updatedQuoteList.get(quoteIndex).set('is_rmi_requiered', action.rmi)
				updatedQuoteList = updatedQuoteList.setIn([quoteIndex], updateQuote)
				return allDetails.setIn([index], detailToChange.set('quotes', updatedQuoteList))
			})
		}
		case requirementRequestActions.REMOVE_SAMPLE_REQUEST_REQUIREMENT_REQUEST_DETAIL: {
			return state.updateIn(['requirementRequestInformation', 'details'], (allDetails) => {
				let index = allDetails.findIndex((detail) => detail.get('token') === action.detailToken)
				if (index === -1) return allDetails
				let detailToChange = allDetails.get(index)
				let quoteIndex = detailToChange
					.get('quotes')
					.findIndex((q) => q.get('supplier_token') === action.supplierToken)
				if (quoteIndex === -1) return allDetails
				let updatedQuoteList = detailToChange.get('quotes')
				let updateQuote = updatedQuoteList.get(quoteIndex).set('is_sample_requiered', false)
				updatedQuoteList = updatedQuoteList.setIn([quoteIndex], updateQuote)
				return allDetails.setIn([index], detailToChange.set('quotes', updatedQuoteList))
			})
		}
		default:
			return state
	}
}
